import { render, staticRenderFns } from "./indexOrdos.vue?vue&type=template&id=612afa86&scoped=true"
import script from "./indexOrdos.vue?vue&type=script&lang=js"
export * from "./indexOrdos.vue?vue&type=script&lang=js"
import style0 from "./indexOrdos.vue?vue&type=style&index=0&id=612afa86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612afa86",
  null
  
)

export default component.exports